import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { reduxForm, Field } from 'redux-form/immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

import FormTextField from 'retired/FormTextField';
import FormFieldLabel from 'retired/FormFieldLabel';
import FormRteField from 'retired/FormRteField';
import { required, isEmail } from 'utils/validators';

import { FORM_IDENTIFIER } from './constants';
import * as Actions from './actions';

const requiredValidator = required();
const isEmailValidator = isEmail();

const EmailAttendeesForm = ({
  actions,
  handleSubmit,
  toggleAction,
  deed,
  open,
  submitting,
  invalid,
  pristine,
}) => {
  useEffect(() => {
    actions.initAction(deed);
  }, []);

  const submit = (data) => {
    actions.sendAction(
      data.get('subject'),
      data.get('message'),
      data.get('fromName'),
      data.get('fromEmail'),
      deed
    );
  };

  if (!open) {
    return null;
  }

  return (
    <Dialog
      open={open}
      onClose={() => toggleAction(false)}
      disableEnforceFocus
      fullWidth
      maxWidth="md"
    >
      <form onSubmit={handleSubmit(submit)}>
        <DialogTitle>Email attendees</DialogTitle>
        <DialogContent>
          <fieldset>
            <Grid container spacing={3} style={{ position: 'relative' }}>
              <Grid item xs={6}>
                <FormFieldLabel forName="fromName">From (Name)</FormFieldLabel>
                <br />
                <Field
                  id="fromName"
                  name="fromName"
                  style={{ width: '100%' }}
                  component={FormTextField}
                  validate={requiredValidator}
                />
              </Grid>
              <Grid item xs={6}>
                <FormFieldLabel forName="fromEmail">From (Email)</FormFieldLabel>
                <br />
                <Field
                  id="fromEmail"
                  name="fromEmail"
                  style={{ width: '100%' }}
                  component={FormTextField}
                  validate={[requiredValidator, isEmailValidator]}
                />
              </Grid>
            </Grid>
            <br />
            <FormFieldLabel forName="subject">Subject</FormFieldLabel>
            <Field
              id="subject"
              name="subject"
              component={FormTextField}
              fullWidth
              validate={requiredValidator}
            />
            <br />
            <br />
            <FormFieldLabel forName="brief">Message</FormFieldLabel>
            <Field
              id="message"
              name="message"
              component={FormRteField}
              required
              validate={requiredValidator}
            />
            <br />
            * You will receive a copy in your inbox.
            <br />* If you’re informing of the cancellation of this Deed, make sure to click the
            &quot;Cancel Deed&quot; button to prevent additional volunteers from signing up.
          </fieldset>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={() => toggleAction(false)}>
            Cancel
          </Button>
          <Button
            color="primary"
            variant="contained"
            type="submit"
            disabled={invalid || submitting || pristine}
          >
            Send
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

EmailAttendeesForm.propTypes = {
  actions: PropTypes.object,
  deed: PropTypes.object,
  handleSubmit: PropTypes.func,
  toggleAction: PropTypes.func,
  open: PropTypes.bool,
  invalid: PropTypes.bool,
  submitting: PropTypes.bool,
  pristine: PropTypes.bool,
};

export default connect(null, (dispatch) => ({
  actions: bindActionCreators(Actions, dispatch),
}))(
  reduxForm({
    form: FORM_IDENTIFIER,
    destroyOnUnmount: false,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(EmailAttendeesForm)
);
